import Cropper from 'cropperjs';

document.addEventListener('DOMContentLoaded', () => {
  const cropperDiv = document.getElementById('store_product_cropper');
  const formDiv = document.getElementById('store_products_form');

  if (cropperDiv == null || formDiv == null) {
    return;
  }

  const closeButton = cropperDiv.querySelector('#store_product_cropper_close') as HTMLElement;
  const productImageFileInput = document.getElementById('chirashiru_store_product_image') as HTMLInputElement;
  const croppedImageHiddenInput = document.getElementById('chirashiru_store_product_cropped_image') as HTMLInputElement;
  const cropperImageArea = document.getElementById('store_product_cropper_area') as HTMLElement;
  const cropperImg = cropperImageArea.querySelector('img') as HTMLImageElement;
  const cropSubmitButton = document.getElementById('store_product_cropper_crop_submit') as HTMLElement;
  const asItIsSubmitButton = document.getElementById('store_product_cropper_as_it_is_submit') as HTMLElement;
  const uploadedProductImagePreview = document.getElementById('uploaded_product_image_preview') as HTMLImageElement;

  const removeCropperContainer = () => {
    const cropperContainers = document.querySelectorAll('.cropper-container');
    cropperContainers.forEach((cropperContainer, index) => {
      cropperContainer.remove();
    });
  }

  const closeModal = () => {
    removeCropperContainer();
    cropperDiv.style.display = 'none';
  }

  const showModal = () => {
    cropperDiv.style.display = 'block';
  }

  const refreshCropper = (img: HTMLImageElement) => {
    const cropper = new Cropper(img, {
      aspectRatio: 1/1,
      zoomable: false
    });
    return cropper;
  }

  const setCropSubmit = (cropper: Cropper) => {
    cropSubmitButton.addEventListener('click', () => {
      if (cropper) {
        const croppedCanvas = cropper.getCroppedCanvas({
          fillColor: '#fff'
        });
        if (croppedCanvas) {
          const dataUrl = croppedCanvas.toDataURL('image/jpeg');
          uploadedProductImagePreview.src = dataUrl;
          croppedImageHiddenInput.value = dataUrl;
        }
        cropper.destroy()
        closeModal();
      }
    });
  };

  productImageFileInput.addEventListener('change', () => {
    const files = productImageFileInput.files;
    if (files && files[0]) {
      const file = files[0];
      const reader = new FileReader();
      reader.addEventListener('load', (e) => {
        if ((e.target as FileReader).result) {
          // モーダルを表示
          showModal();
          cropperImg.src = (e.target as any).result || '';
          // Cropperを起動
          const cropper = refreshCropper(cropperImg);
          // Set Close Event
          setCloseEventWithCropper(cropper);
          // Set Crop submit
          setCropSubmit(cropper);
        }
      });
      // 画像データを読み込む
      reader.readAsDataURL(file);
    }
  });

  const setCloseEventWithCropper = (cropper: Cropper) => {
    closeButton.addEventListener('click', () => {
      if (cropper) {
        cropper.destroy();
        closeModal();
      }
    });
    asItIsSubmitButton.addEventListener('click', () => {
      if (cropper) {
        cropper.destroy();
        closeModal();
      }
    });
  }
});
